export const mockEmbeddedPartnersQueryData = [
  {
    squareLogo:
      'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
    id: '1734',
    name: 'Packt',
    slug: 'packt',
  },
  {
    squareLogo:
      'http://coursera-university-assets.s3.amazonaws.com/cc/61dbdf2c1c475d82d3b8bf8eee1bda/MSFT-stacked-logo_FINAL.png',
    id: '705',
    name: 'Microsoft',
    slug: 'microsoft',
  },
  {
    squareLogo:
      'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
    id: '463',
    name: 'Google',
    slug: 'google',
  },
  {
    squareLogo:
      'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
    id: '1504',
    name: 'Edureka',
    slug: 'edureka',
  },
  {
    squareLogo:
      'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
    id: '348',
    name: 'IBM',
    slug: 'ibm-skills-network',
  },
];
